export const API_ENDPOINT = process.env.NEXT_PUBLIC_API_ENDPOINT ?? 'http://127.0.0.1:8000'
export const API_SERVICES = {
  authToken: '/api/auth-token/'
}

export const NO_IMAGE_URL = '/assets/images/resources/no-image-found.jpg'
